import { createReducer, on } from '@ngrx/store';
import {
  cancelPermitRequest,
  cancelPermitRequestFailed,
  cancelPermitRequestReceived,
  getOperatingAuthorityApplicationData,
  getOperatingAuthorityApplicationDataReceived,
  getOperatingAuthorityApplicationDocumentsData,
  getOperatingAuthorityApplicationDocumentsDataReceived,
  getOperatingAuthorityApplicationFeesData,
  getOperatingAuthorityApplicationFeesDataReceived,
  getOperatingAuthorityApplicationInvoicesData,
  getOperatingAuthorityApplicationInvoicesDataReceived,
  submitPermitRequest,
  submitPermitRequestReceived,
} from '../actions/operatingAuthorityApplicationAction';
import { operatingAuthorityApplicationStateDataType } from '../../core/models/Interfaces/operatingAuthorityApplication';

const initialState: operatingAuthorityApplicationStateDataType = {
  isFetchingOperatingAuthorityApplication: false,
  operatingAuthorityApplicationData: null,
  isFetchingOaaFees: false,
  oaaFeesData: null,
  isFetchingOaaInvoices: false,
  oaaInvoicesData: null,
  isFetchingDocuments: false,
  documentsData: null,
  isSubmittingPermitRequest: false,
  isTerminatingPermitRequest: false,
};

export const operatingAuthorityApplicationReducer = createReducer(
  initialState,
  on(getOperatingAuthorityApplicationData, (state, data) => {
    return {
      ...state,
      isFetchingOperatingAuthorityApplication: true,
    };
  }),
  on(getOperatingAuthorityApplicationDataReceived, (state, data) => {
    return {
      ...state,
      isFetchingOperatingAuthorityApplication: false,
      operatingAuthorityApplicationData: data.params,
    };
  }),
  on(getOperatingAuthorityApplicationFeesData, (state, data) => {
    return {
      ...state,
      isFetchingOaaFees: true,
    };
  }),
  on(getOperatingAuthorityApplicationFeesDataReceived, (state, data) => {
    return {
      ...state,
      isFetchingOaaFees: false,
      oaaFeesData: data.params,
    };
  }),
  on(getOperatingAuthorityApplicationInvoicesData, (state, data) => {
    return {
      ...state,
      isFetchingOaaInvoices: true,
    };
  }),
  on(getOperatingAuthorityApplicationInvoicesDataReceived, (state, data) => {
    return {
      ...state,
      isFetchingOaaInvoices: false,
      oaaInvoicesData: data.params,
    };
  }),
  on(getOperatingAuthorityApplicationDocumentsData, (state, data) => {
    return {
      ...state,
      isFetchingDocuments: true,
    };
  }),
  on(getOperatingAuthorityApplicationDocumentsDataReceived, (state, data) => {
    return {
      ...state,
      isFetchingDocuments: false,
      documentsData: data.params,
    };
  }),
  on(submitPermitRequest, (state, data) => {
    return {
      ...state,
      isSubmittingPermitRequest: true,
    };
  }),
  on(submitPermitRequestReceived, (state, data) => {
    return {
      ...state,
      isSubmittingPermitRequest: false,
    };
  }),
  on(cancelPermitRequest, (state, data) => {
    return {
      ...state,
      isTerminatingPermitRequest: true,
    };
  }),
  on(cancelPermitRequestReceived, (state, data) => {
    return {
      ...state,
      isTerminatingPermitRequest: false,
    };
  }),
  on(cancelPermitRequestFailed, (state, data) => {
    return {
      ...state,
      isTerminatingPermitRequest: false,
    };
  }),
);
